/* tslint:disable */
/* eslint-disable */
/**
 * NORA Api
 *  ## Headers  ### X-App-Version  Remember to include the `X-App-Version` header in every request. This will verify that the app version works with this API version. The API will return a `X-Minimum-App-Version` header as well including the minimum app version that is supported by this API. The contents of the header are is a JSON encoded DTO, `VersionHeaderDTO`. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiResult } from '../models';
// @ts-ignore
import type { CreateFolderRequest } from '../models';
// @ts-ignore
import type { DeleteFolderRequest } from '../models';
// @ts-ignore
import type { GetFileMetadata200Response } from '../models';
// @ts-ignore
import type { GetOperationFiles200Response } from '../models';
// @ts-ignore
import type { GetRecentFiles200Response } from '../models';
// @ts-ignore
import type { GetRootFolderForUser200Response } from '../models';
// @ts-ignore
import type { GetUploadUrl200Response } from '../models';
// @ts-ignore
import type { RenameFile200Response } from '../models';
// @ts-ignore
import type { RenameFileRequest } from '../models';
// @ts-ignore
import type { RenameFolder200Response } from '../models';
// @ts-ignore
import type { RenameFolderRequest } from '../models';
// @ts-ignore
import type { SearchGroupsAdmin200Response } from '../models';
// @ts-ignore
import type { SignedUrlUploadRequest } from '../models';
// @ts-ignore
import type { UpdateFileLocationRequest } from '../models';
/**
 * FileApi - axios parameter creator
 */
export const FileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary browse
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        browse: async (path: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'path' is not null or undefined
            assertParamExists('browse', 'path', path)
            const localVarPath = `/api/nora/file/browse`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary createFolder
         * @param {CreateFolderRequest} createFolderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFolder: async (createFolderRequest: CreateFolderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createFolderRequest' is not null or undefined
            assertParamExists('createFolder', 'createFolderRequest', createFolderRequest)
            const localVarPath = `/api/nora/file/folder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFolderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The file must be valid, have a valid domain and domainId description, and the user must have access to delete the file.
         * @summary Deletes the given file
         * @param {string} domain 
         * @param {string} domainId 
         * @param {string} fileId 
         * @param {string} [path] An optional subpath for the file. Will default to root path: \&#39;/\&#39;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFile: async (domain: string, domainId: string, fileId: string, path?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'domain' is not null or undefined
            assertParamExists('deleteFile', 'domain', domain)
            // verify required parameter 'domainId' is not null or undefined
            assertParamExists('deleteFile', 'domainId', domainId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('deleteFile', 'fileId', fileId)
            const localVarPath = `/api/nora/file/{domain}/{domainId}/{fileId}`
                .replace('{domain}', encodeURIComponent(String(domain)))
                .replace('{domainId}', encodeURIComponent(String(domainId)))
                .replace('{fileId}', encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteFolder
         * @param {DeleteFolderRequest} deleteFolderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFolder: async (deleteFolderRequest: DeleteFolderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteFolderRequest' is not null or undefined
            assertParamExists('deleteFolder', 'deleteFolderRequest', deleteFolderRequest)
            const localVarPath = `/api/nora/file/folder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteFolderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns an object containing file metadata, along with a urls object that may contain urls to fetch the file and the file\'s thumbnail.
         * @param {string} domain 
         * @param {string} domainId 
         * @param {string} fileId 
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileMetadata: async (domain: string, domainId: string, fileId: string, path: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'domain' is not null or undefined
            assertParamExists('getFileMetadata', 'domain', domain)
            // verify required parameter 'domainId' is not null or undefined
            assertParamExists('getFileMetadata', 'domainId', domainId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('getFileMetadata', 'fileId', fileId)
            // verify required parameter 'path' is not null or undefined
            assertParamExists('getFileMetadata', 'path', path)
            const localVarPath = `/api/nora/file/{domain}/{domainId}/{fileId}`
                .replace('{domain}', encodeURIComponent(String(domain)))
                .replace('{domainId}', encodeURIComponent(String(domainId)))
                .replace('{fileId}', encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getRecentFiles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentFiles: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/file/recent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getRootFolderForUser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRootFolderForUser: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/file/root`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getUploadUrl
         * @param {SignedUrlUploadRequest} signedUrlUploadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUploadUrl: async (signedUrlUploadRequest: SignedUrlUploadRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'signedUrlUploadRequest' is not null or undefined
            assertParamExists('getUploadUrl', 'signedUrlUploadRequest', signedUrlUploadRequest)
            const localVarPath = `/api/nora/file/url/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(signedUrlUploadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary renameFile
         * @param {string} domain 
         * @param {string} domainId 
         * @param {string} fileId 
         * @param {string} path 
         * @param {RenameFileRequest} renameFileRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameFile: async (domain: string, domainId: string, fileId: string, path: string, renameFileRequest: RenameFileRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'domain' is not null or undefined
            assertParamExists('renameFile', 'domain', domain)
            // verify required parameter 'domainId' is not null or undefined
            assertParamExists('renameFile', 'domainId', domainId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('renameFile', 'fileId', fileId)
            // verify required parameter 'path' is not null or undefined
            assertParamExists('renameFile', 'path', path)
            // verify required parameter 'renameFileRequest' is not null or undefined
            assertParamExists('renameFile', 'renameFileRequest', renameFileRequest)
            const localVarPath = `/api/nora/file/{domain}/{domainId}/{fileId}/rename`
                .replace('{domain}', encodeURIComponent(String(domain)))
                .replace('{domainId}', encodeURIComponent(String(domainId)))
                .replace('{fileId}', encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(renameFileRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary renameFolder
         * @param {RenameFolderRequest} renameFolderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameFolder: async (renameFolderRequest: RenameFolderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'renameFolderRequest' is not null or undefined
            assertParamExists('renameFolder', 'renameFolderRequest', renameFolderRequest)
            const localVarPath = `/api/nora/file/folder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(renameFolderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary searchFiles
         * @param {string} [domain] 
         * @param {string} [domainId] 
         * @param {string} [query] 
         * @param {string} [path] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFiles: async (domain?: string, domainId?: string, query?: string, path?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/file/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            if (domain !== undefined) {
                localVarQueryParameter['domain'] = domain;
            }

            if (domainId !== undefined) {
                localVarQueryParameter['domainId'] = domainId;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary searchFilesInPolygon
         * @param {string} polygon A polygon string, formatted as latitude,longitude,latitude,longitude,....
         * @param {string} [operationId] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFilesInPolygon: async (polygon: string, operationId?: string, query?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'polygon' is not null or undefined
            assertParamExists('searchFilesInPolygon', 'polygon', polygon)
            const localVarPath = `/api/nora/file/search/geo/polygon`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            if (polygon !== undefined) {
                localVarQueryParameter['polygon'] = polygon;
            }

            if (operationId !== undefined) {
                localVarQueryParameter['operationId'] = operationId;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateFileLocation
         * @param {string} domain 
         * @param {string} domainId 
         * @param {string} fileId 
         * @param {string} path 
         * @param {UpdateFileLocationRequest} updateFileLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFileLocation: async (domain: string, domainId: string, fileId: string, path: string, updateFileLocationRequest: UpdateFileLocationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'domain' is not null or undefined
            assertParamExists('updateFileLocation', 'domain', domain)
            // verify required parameter 'domainId' is not null or undefined
            assertParamExists('updateFileLocation', 'domainId', domainId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('updateFileLocation', 'fileId', fileId)
            // verify required parameter 'path' is not null or undefined
            assertParamExists('updateFileLocation', 'path', path)
            // verify required parameter 'updateFileLocationRequest' is not null or undefined
            assertParamExists('updateFileLocation', 'updateFileLocationRequest', updateFileLocationRequest)
            const localVarPath = `/api/nora/file/{domain}/{domainId}/{fileId}/location`
                .replace('{domain}', encodeURIComponent(String(domain)))
                .replace('{domainId}', encodeURIComponent(String(domainId)))
                .replace('{fileId}', encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFileLocationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FileApi - functional programming interface
 */
export const FileApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FileApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary browse
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async browse(path: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOperationFiles200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.browse(path, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileApi.browse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary createFolder
         * @param {CreateFolderRequest} createFolderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFolder(createFolderRequest: CreateFolderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RenameFolder200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFolder(createFolderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileApi.createFolder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The file must be valid, have a valid domain and domainId description, and the user must have access to delete the file.
         * @summary Deletes the given file
         * @param {string} domain 
         * @param {string} domainId 
         * @param {string} fileId 
         * @param {string} [path] An optional subpath for the file. Will default to root path: \&#39;/\&#39;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFile(domain: string, domainId: string, fileId: string, path?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFile(domain, domainId, fileId, path, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileApi.deleteFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary deleteFolder
         * @param {DeleteFolderRequest} deleteFolderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFolder(deleteFolderRequest: DeleteFolderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFolder(deleteFolderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileApi.deleteFolder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns an object containing file metadata, along with a urls object that may contain urls to fetch the file and the file\'s thumbnail.
         * @param {string} domain 
         * @param {string} domainId 
         * @param {string} fileId 
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFileMetadata(domain: string, domainId: string, fileId: string, path: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFileMetadata200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFileMetadata(domain, domainId, fileId, path, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileApi.getFileMetadata']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary getRecentFiles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecentFiles(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRecentFiles200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecentFiles(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileApi.getRecentFiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary getRootFolderForUser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRootFolderForUser(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRootFolderForUser200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRootFolderForUser(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileApi.getRootFolderForUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary getUploadUrl
         * @param {SignedUrlUploadRequest} signedUrlUploadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUploadUrl(signedUrlUploadRequest: SignedUrlUploadRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUploadUrl200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUploadUrl(signedUrlUploadRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileApi.getUploadUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary renameFile
         * @param {string} domain 
         * @param {string} domainId 
         * @param {string} fileId 
         * @param {string} path 
         * @param {RenameFileRequest} renameFileRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async renameFile(domain: string, domainId: string, fileId: string, path: string, renameFileRequest: RenameFileRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RenameFile200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.renameFile(domain, domainId, fileId, path, renameFileRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileApi.renameFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary renameFolder
         * @param {RenameFolderRequest} renameFolderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async renameFolder(renameFolderRequest: RenameFolderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RenameFolder200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.renameFolder(renameFolderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileApi.renameFolder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary searchFiles
         * @param {string} [domain] 
         * @param {string} [domainId] 
         * @param {string} [query] 
         * @param {string} [path] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchFiles(domain?: string, domainId?: string, query?: string, path?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchGroupsAdmin200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchFiles(domain, domainId, query, path, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileApi.searchFiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary searchFilesInPolygon
         * @param {string} polygon A polygon string, formatted as latitude,longitude,latitude,longitude,....
         * @param {string} [operationId] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchFilesInPolygon(polygon: string, operationId?: string, query?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchGroupsAdmin200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchFilesInPolygon(polygon, operationId, query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileApi.searchFilesInPolygon']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary updateFileLocation
         * @param {string} domain 
         * @param {string} domainId 
         * @param {string} fileId 
         * @param {string} path 
         * @param {UpdateFileLocationRequest} updateFileLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFileLocation(domain: string, domainId: string, fileId: string, path: string, updateFileLocationRequest: UpdateFileLocationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RenameFile200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFileLocation(domain, domainId, fileId, path, updateFileLocationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileApi.updateFileLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FileApi - factory interface
 */
export const FileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FileApiFp(configuration)
    return {
        /**
         * 
         * @summary browse
         * @param {FileApiBrowseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        browse(requestParameters: FileApiBrowseRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetOperationFiles200Response> {
            return localVarFp.browse(requestParameters.path, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary createFolder
         * @param {FileApiCreateFolderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFolder(requestParameters: FileApiCreateFolderRequest, options?: RawAxiosRequestConfig): AxiosPromise<RenameFolder200Response> {
            return localVarFp.createFolder(requestParameters.createFolderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * The file must be valid, have a valid domain and domainId description, and the user must have access to delete the file.
         * @summary Deletes the given file
         * @param {FileApiDeleteFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFile(requestParameters: FileApiDeleteFileRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.deleteFile(requestParameters.domain, requestParameters.domainId, requestParameters.fileId, requestParameters.path, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteFolder
         * @param {FileApiDeleteFolderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFolder(requestParameters: FileApiDeleteFolderRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.deleteFolder(requestParameters.deleteFolderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns an object containing file metadata, along with a urls object that may contain urls to fetch the file and the file\'s thumbnail.
         * @param {FileApiGetFileMetadataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileMetadata(requestParameters: FileApiGetFileMetadataRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetFileMetadata200Response> {
            return localVarFp.getFileMetadata(requestParameters.domain, requestParameters.domainId, requestParameters.fileId, requestParameters.path, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getRecentFiles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentFiles(options?: RawAxiosRequestConfig): AxiosPromise<GetRecentFiles200Response> {
            return localVarFp.getRecentFiles(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getRootFolderForUser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRootFolderForUser(options?: RawAxiosRequestConfig): AxiosPromise<GetRootFolderForUser200Response> {
            return localVarFp.getRootFolderForUser(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getUploadUrl
         * @param {FileApiGetUploadUrlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUploadUrl(requestParameters: FileApiGetUploadUrlRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetUploadUrl200Response> {
            return localVarFp.getUploadUrl(requestParameters.signedUrlUploadRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary renameFile
         * @param {FileApiRenameFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameFile(requestParameters: FileApiRenameFileRequest, options?: RawAxiosRequestConfig): AxiosPromise<RenameFile200Response> {
            return localVarFp.renameFile(requestParameters.domain, requestParameters.domainId, requestParameters.fileId, requestParameters.path, requestParameters.renameFileRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary renameFolder
         * @param {FileApiRenameFolderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameFolder(requestParameters: FileApiRenameFolderRequest, options?: RawAxiosRequestConfig): AxiosPromise<RenameFolder200Response> {
            return localVarFp.renameFolder(requestParameters.renameFolderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary searchFiles
         * @param {FileApiSearchFilesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFiles(requestParameters: FileApiSearchFilesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SearchGroupsAdmin200Response> {
            return localVarFp.searchFiles(requestParameters.domain, requestParameters.domainId, requestParameters.query, requestParameters.path, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary searchFilesInPolygon
         * @param {FileApiSearchFilesInPolygonRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFilesInPolygon(requestParameters: FileApiSearchFilesInPolygonRequest, options?: RawAxiosRequestConfig): AxiosPromise<SearchGroupsAdmin200Response> {
            return localVarFp.searchFilesInPolygon(requestParameters.polygon, requestParameters.operationId, requestParameters.query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateFileLocation
         * @param {FileApiUpdateFileLocationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFileLocation(requestParameters: FileApiUpdateFileLocationRequest, options?: RawAxiosRequestConfig): AxiosPromise<RenameFile200Response> {
            return localVarFp.updateFileLocation(requestParameters.domain, requestParameters.domainId, requestParameters.fileId, requestParameters.path, requestParameters.updateFileLocationRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for browse operation in FileApi.
 */
export interface FileApiBrowseRequest {
    readonly path: string
}

/**
 * Request parameters for createFolder operation in FileApi.
 */
export interface FileApiCreateFolderRequest {
    readonly createFolderRequest: CreateFolderRequest
}

/**
 * Request parameters for deleteFile operation in FileApi.
 */
export interface FileApiDeleteFileRequest {
    readonly domain: string

    readonly domainId: string

    readonly fileId: string

    /**
     * An optional subpath for the file. Will default to root path: \&#39;/\&#39;
     */
    readonly path?: string
}

/**
 * Request parameters for deleteFolder operation in FileApi.
 */
export interface FileApiDeleteFolderRequest {
    readonly deleteFolderRequest: DeleteFolderRequest
}

/**
 * Request parameters for getFileMetadata operation in FileApi.
 */
export interface FileApiGetFileMetadataRequest {
    readonly domain: string

    readonly domainId: string

    readonly fileId: string

    readonly path: string
}

/**
 * Request parameters for getUploadUrl operation in FileApi.
 */
export interface FileApiGetUploadUrlRequest {
    readonly signedUrlUploadRequest: SignedUrlUploadRequest
}

/**
 * Request parameters for renameFile operation in FileApi.
 */
export interface FileApiRenameFileRequest {
    readonly domain: string

    readonly domainId: string

    readonly fileId: string

    readonly path: string

    readonly renameFileRequest: RenameFileRequest
}

/**
 * Request parameters for renameFolder operation in FileApi.
 */
export interface FileApiRenameFolderRequest {
    readonly renameFolderRequest: RenameFolderRequest
}

/**
 * Request parameters for searchFiles operation in FileApi.
 */
export interface FileApiSearchFilesRequest {
    readonly domain?: string

    readonly domainId?: string

    readonly query?: string

    readonly path?: string
}

/**
 * Request parameters for searchFilesInPolygon operation in FileApi.
 */
export interface FileApiSearchFilesInPolygonRequest {
    /**
     * A polygon string, formatted as latitude,longitude,latitude,longitude,....
     */
    readonly polygon: string

    readonly operationId?: string

    readonly query?: string
}

/**
 * Request parameters for updateFileLocation operation in FileApi.
 */
export interface FileApiUpdateFileLocationRequest {
    readonly domain: string

    readonly domainId: string

    readonly fileId: string

    readonly path: string

    readonly updateFileLocationRequest: UpdateFileLocationRequest
}

/**
 * FileApi - object-oriented interface
 */
export class FileApi extends BaseAPI {
    /**
     * 
     * @summary browse
     * @param {FileApiBrowseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public browse(requestParameters: FileApiBrowseRequest, options?: RawAxiosRequestConfig) {
        return FileApiFp(this.configuration).browse(requestParameters.path, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary createFolder
     * @param {FileApiCreateFolderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createFolder(requestParameters: FileApiCreateFolderRequest, options?: RawAxiosRequestConfig) {
        return FileApiFp(this.configuration).createFolder(requestParameters.createFolderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The file must be valid, have a valid domain and domainId description, and the user must have access to delete the file.
     * @summary Deletes the given file
     * @param {FileApiDeleteFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteFile(requestParameters: FileApiDeleteFileRequest, options?: RawAxiosRequestConfig) {
        return FileApiFp(this.configuration).deleteFile(requestParameters.domain, requestParameters.domainId, requestParameters.fileId, requestParameters.path, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteFolder
     * @param {FileApiDeleteFolderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteFolder(requestParameters: FileApiDeleteFolderRequest, options?: RawAxiosRequestConfig) {
        return FileApiFp(this.configuration).deleteFolder(requestParameters.deleteFolderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns an object containing file metadata, along with a urls object that may contain urls to fetch the file and the file\'s thumbnail.
     * @param {FileApiGetFileMetadataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFileMetadata(requestParameters: FileApiGetFileMetadataRequest, options?: RawAxiosRequestConfig) {
        return FileApiFp(this.configuration).getFileMetadata(requestParameters.domain, requestParameters.domainId, requestParameters.fileId, requestParameters.path, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getRecentFiles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRecentFiles(options?: RawAxiosRequestConfig) {
        return FileApiFp(this.configuration).getRecentFiles(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getRootFolderForUser
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRootFolderForUser(options?: RawAxiosRequestConfig) {
        return FileApiFp(this.configuration).getRootFolderForUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getUploadUrl
     * @param {FileApiGetUploadUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUploadUrl(requestParameters: FileApiGetUploadUrlRequest, options?: RawAxiosRequestConfig) {
        return FileApiFp(this.configuration).getUploadUrl(requestParameters.signedUrlUploadRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary renameFile
     * @param {FileApiRenameFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public renameFile(requestParameters: FileApiRenameFileRequest, options?: RawAxiosRequestConfig) {
        return FileApiFp(this.configuration).renameFile(requestParameters.domain, requestParameters.domainId, requestParameters.fileId, requestParameters.path, requestParameters.renameFileRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary renameFolder
     * @param {FileApiRenameFolderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public renameFolder(requestParameters: FileApiRenameFolderRequest, options?: RawAxiosRequestConfig) {
        return FileApiFp(this.configuration).renameFolder(requestParameters.renameFolderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary searchFiles
     * @param {FileApiSearchFilesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchFiles(requestParameters: FileApiSearchFilesRequest = {}, options?: RawAxiosRequestConfig) {
        return FileApiFp(this.configuration).searchFiles(requestParameters.domain, requestParameters.domainId, requestParameters.query, requestParameters.path, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary searchFilesInPolygon
     * @param {FileApiSearchFilesInPolygonRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchFilesInPolygon(requestParameters: FileApiSearchFilesInPolygonRequest, options?: RawAxiosRequestConfig) {
        return FileApiFp(this.configuration).searchFilesInPolygon(requestParameters.polygon, requestParameters.operationId, requestParameters.query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateFileLocation
     * @param {FileApiUpdateFileLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateFileLocation(requestParameters: FileApiUpdateFileLocationRequest, options?: RawAxiosRequestConfig) {
        return FileApiFp(this.configuration).updateFileLocation(requestParameters.domain, requestParameters.domainId, requestParameters.fileId, requestParameters.path, requestParameters.updateFileLocationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

